import React, { memo } from "react";
import { Link } from "react-router-dom";

export const EditLink = memo<{ record: { id: string }; children: React.ReactNode }>(
  ({ record, children }) => <Link to={`/notifications/${record.id}/edit`}>{children}</Link>,
);
